export const LOGIN_PASSWORDLESS_PATH = "validar-credenciais";
export const MFA_AUTH_PATH = "confirmar-identidade";
export const SIGNUP_PATH = "cadastro";
export const URL_PROD_YOUR_ACCOUNT = "https%3A//www.magazineluiza.com.br";
export const URL_STAGING_YOUR_ACCOUNT =
  "https%3A//imperio-sandbox.luizalabs.com";
